import { Button, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip } from "@material-ui/core";
import React, { useMemo } from "react";
import { ChatAvatar } from "../../../../digitalArena/modules/ChatModule/components/ChatAvatar";
import { combineProps, deepClone } from "../../../../helpers/objectHelper";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import VideocamIcon from "@material-ui/icons/Videocam";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { VideoCallButton } from "../../../shared/VideoCallButton";
import { LinkedInButton } from "../../../shared/LinkedInButton";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import GroupAvatars from "../../../../components/GroupAvatars";

export const ActiveVisitorList = (props) => {
  const { orderList, connectionList = [], exhibitorsHosts = [], peopleFilter, selectChat, exhibitorId, videoRequest, nonAvailablePersons = [], chat } = props;

  const activeVisitors = useMemo(() => {
    return orderList.filter((o) => {
      if (o.anonymous == true) return false;
      return connectionList.find((v) => v.clientKey == o.badgeNo);
    });
  }, [connectionList, exhibitorsHosts, props.nonAvailablePersons, chat]);

  return (
    <List style={{ overflowY: "auto" }}>
      {activeVisitors
        .filter((a) => {
          if (peopleFilter == "ATTENDEES" && (a.exhibitorId == null || a.exhibitorId != exhibitorId)) {
            return true;
          }
          if (peopleFilter == "EXHIBITORS" && a.exhibitorId == exhibitorId) {
            return true;
          }
          return false;
        })
        .map((v, i) => {
          const isHost = orderList.find((e) => e.badgeNo == v.badgeNo && e.exhibitorId == exhibitorId);
          const initHostChats = chat
            .find((c) => c.target == "EXPO")
            ?.messages?.filter((f) => f.receiver == v.badgeNo)
            ?.map((m) => {
              return m.sender;
            });
          const connectedHosts = initHostChats ? orderList.filter((o) => initHostChats.includes(o.badgeNo)) : [];

          return (
            <React.Fragment key={i}>
              <ListItem>
                <ListItemAvatar>
                  <>
                    {isHost ? <VerifiedUserIcon className="expo-admin-icon" /> : null}
                    <ChatAvatar
                      {...combineProps([
                        props,
                        {
                          connectionList,
                          orderList,
                          primaryColor: "#e4e6eb",
                          secondaryColor: "#fff",
                          target: v.badgeNo,
                        },
                      ])}
                    ></ChatAvatar>
                  </>
                </ListItemAvatar>
                <ListItemText primary={v.name} secondary={v.company} />
                {connectedHosts.length > 0 ? (
                  <ListItemText
                    primary={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SyncAltIcon style={{ marginRight: 10 }} />
                        <GroupAvatars people={connectedHosts} target={v.name} />
                      </div>
                    }
                  />
                ) : null}
                <ListItemSecondaryAction>
                  <LinkedInButton tooltipTitle={<EventLabel2 name="VisitLinkedInProfile" groupName="Exhibitor.Admin" />} {...v} />

                  <IconButton onClick={() => selectChat(v.badgeNo)}>
                    <Tooltip title={<EventLabel2 name="Chat" groupName="Exhibitor.Admin" />}>
                      <ChatBubbleIcon />
                    </Tooltip>
                  </IconButton>

                  <VideoCallButton tooltipTitle={<EventLabel2 name="StartVideoMeeting" groupName="Exhibitor.Admin" />} {...combineProps([props, { badgeNo: v.badgeNo }])} />
                </ListItemSecondaryAction>
              </ListItem>
              <Divider variant="inset" component="li" />
            </React.Fragment>
          );
        })}
    </List >
  );
};
